import { z } from "zod";

/**
 * Geographic coordinates schema
 */
const LatLngSchema = z.object({
  latitude: z.number().min(-90).max(90).describe("Latitude coordinate"),
  longitude: z.number().min(-180).max(180).describe("Longitude coordinate"),
});

/**
 * Location/venue schema for dating app
 * Represents date venues, events, or points of interest
 */
export const LocationSchema = z.object({
  /** Name of the location or venue */
  name: z.string().optional().describe("Name of the location or venue"),

  /** Geographic coordinates */
  position: LatLngSchema.optional().describe("Latitude and longitude coordinates"),

  /** Event timing information */
  event_time: z.string().optional().describe("Event time or schedule information"),

  /** Array of image URLs for the location */
  images: z.array(z.string().url()).optional().describe("URLs of location images"),

  /** Description or biography of the location */
  bio: z.string().optional().describe("Description of the location"),

  /** Physical address */
  address: z.string().optional().describe("Street address of the location"),

  /** Website URL */
  website: z.url().optional().describe("Location's website URL"),
});

export type Location = z.infer<typeof LocationSchema>;
export type LatLng = z.infer<typeof LatLngSchema>;
